import { useBlockExtender } from "@hooks";
import { ExtendedAccount } from "@features/depots/types";
import { AccountDetailsChips } from "./AccountDetailsChips";

export const cardExtenderConfig = {
  "kpmg-germany": AccountDetailsChips,
};

export const CardExtender = ({ account }: { account: ExtendedAccount }) =>
  useBlockExtender(cardExtenderConfig, { account });
